export default {
    PRIZEMIE: "PRIZEMIE",
    POS1: "POS1",
    POS2: "POS2"
}